import React from "react";
import {
   EMPLOYMENT_STATUS_OPTIONS,
   MARITAL_STATUS_OPTIONS,
   TITLE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";

import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import {isEmployed} from "@functions/employments";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";

import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import {ValidateStep1Data} from "@validators/business-insurance-form/step1-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step1(
   {
      data,
      handlers,
      setCurrentStep
   }
) {
   
   const STEP = 1;
   
   function onNextBtnClick() {
      
      let validationResult = ValidateStep1Data(data);
      
      /*validationResult.push({
          name : 'halt',
          message : 'Halt'
      });*/
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         })
         
         
      } else {
         setCurrentStep(STEP + 1);
      }
      
      
   }
   
   function onPrevBtnClick() {
      setCurrentStep(STEP - 1);
   }
   
   return (
      <div className={`if-step-${STEP}`}>
         
         <SectionHeading
            text="Personal Info"
         />
         
         <div className="row">
            
            {/* Title */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 extra"
               labelText="Title"
               required={true}
               controlName="title"
               options={TITLE_OPTIONS}
               selectedValues={data.title}
               onChange={handlers.onControlChange}
            />
         
         </div>
         
         
         <div className="row name-block">
            
            {/* First name */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="First name"
               required={true}
               controlName="firstName"
               value={data.firstName}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Last name */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Last name"
               required={true}
               controlName="lastName"
               value={data.lastName}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Date of birth */}
            
            <ScrollableCustomDateTimePickerBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Date of birth"
               required={true}
               controlName="birthDate"
               value={data.birthDate}
               onChange={handlers.onControlChange}
               useSplitDate={true}
            />
         
         
         </div>
         
         <div className="row other-block">
            
            {/* Employment status */}
            
            <ScrollableDropdownBlock
               controlName="employmentStatus"
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Employment status"
               required={true}
               options={EMPLOYMENT_STATUS_OPTIONS}
               selectedValues={data.employmentStatus}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         {isEmployed(data.employmentStatus) && (
            <div className="row pb-3 mb-3 hidden-box p-3">
               
               {/* Main Occupation */}
               
               <ScrollableTextBoxBlock
                  containerCssClass="col-12 py-3 col-md-6"
                  labelText="What's your main occupation?"
                  required={true}
                  controlName="mainOccupation"
                  value={data.mainOccupation}
                  onChange={handlers.onControlChange}
                  inputAttrs={{
                     maxLength: 50
                  }}
               />
               
               {/* Occupation Industry */}
               
               <ScrollableTextBoxBlock
                  containerCssClass="col-12 py-3 col-md-6"
                  labelText="What industry is this occupation in?"
                  required={true}
                  controlName="occupationIndustry"
                  value={data.occupationIndustry}
                  onChange={handlers.onControlChange}
                  asTextArea={false}
                  inputAttrs={{
                     maxLength: 50
                  }}
               />
            
            </div>
         )}
         
         <WizardStepButtonsBlock
            onPrevBtnClick={onPrevBtnClick}
            onNextBtnClick={onNextBtnClick}
            nextButtonAdditionalCssClass={``}
         />
      
      
      </div>
   )
}